"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRides = useRides;
var _maplibreGl = require("maplibre-gl");
var _react = _interopRequireWildcard(require("react"));
var _client = require("react-dom/client");
var _mapArrow = _interopRequireDefault(require("../../assets/images/ride/map-arrow.png"));
var _rideStepMarker = _interopRequireDefault(require("../../assets/images/ride/ride-step-marker.svg"));
var _components = require("../../components");
var _utils = require("../../utils");
var _clusters = require("./clusters");
var _layers = require("./layers");
var _popup = require("./popup");
var _source = require("./source");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ridesSourceId = 'rides';
const ridesLayerId = 'rides';
const arrowRideLayerId = 'arrow-ride';
const ridesStepsLayerId = 'rides-steps';
const clusterRidesSourceId = 'clustered-rides';
// FIXME: use useBikeRoutes instead
const bikeRoutesSourceId = '_bike-routes';
const bikeRoutesLayerId = '_bike-routes';
const bikeRoutesStepsLayerId = '_bike-routes-steps';
function useRides(map, theme, _rides, _bikeRoutes, _enabled = true, {
  onClick,
  openStepPhotoDialog,
  onEdit,
  onRemove
} = {}) {
  const [selectedRide, selectRide] = (0, _react.useState)(null);
  const [selectedRideStepId, selectRideStepId] = (0, _react.useState)(null);
  const initialized = (0, _react.useRef)(false);
  const enabled = (0, _react.useRef)(_enabled);
  const rides = (0, _react.useRef)(_rides);
  const selectedRideRef = (0, _react.useRef)(null);
  const selectedRideStepIdRef = (0, _react.useRef)(null);
  const bikeRoutes = (0, _react.useRef)(_bikeRoutes);
  const markers = (0, _react.useRef)({});
  const stepMarkers = (0, _react.useRef)({});
  const rideTooltip = (0, _react.useRef)(null);
  const rideStepTooltip = (0, _react.useRef)(null);
  const {
    getGeoJSONSource: getRidesSource,
    addGeoJSONSource: addRidesSource,
    updateGeoJSONSource: updateRidesSource,
    clearGeoJSONSource: clearRidesSource
  } = (0, _source.useSource)(map, ridesSourceId);
  const {
    addGeoJSONSource: addBikeRoutesSource,
    updateGeoJSONSource: updateBikeRoutesSource,
    clearGeoJSONSource: clearBikeRoutesSource
  } = (0, _source.useSource)(map, bikeRoutesSourceId);
  const {
    addLineLayer,
    addCircleLayer
  } = (0, _layers.useLayers)(map);
  const {
    init: initClusters,
    update: _updateClusters,
    updateData: updateClustersData,
    clear: clearClusters
  } = (0, _clusters.useClusters)(map, clusterRidesSourceId, undefined, '#326AC2');
  const {
    centerPopup
  } = (0, _popup.usePopup)(map);
  (0, _react.useEffect)(() => {
    enabled.current = _enabled;
    if (_enabled && rides.current) updateClusters();
  }, [_enabled]);
  (0, _react.useEffect)(() => {
    rides.current = _rides;
  }, [_rides]);
  (0, _react.useEffect)(() => {
    bikeRoutes.current = _bikeRoutes;
    if (initialized.current && _enabled && !selectedRideRef.current && _rides && _bikeRoutes) {
      updateBikeRoutesSource({
        type: 'FeatureCollection',
        features: _bikeRoutes.sort((a, b) => b.id - a.id).reduce((res, {
          rides,
          primaryColor
        }) => {
          const color = primaryColor || '#326ac2';
          rides.forEach(({
            rideId,
            prevRideId
          }) => {
            const ride = _rides.find(({
              id
            }) => id === rideId);
            if (ride) {
              const {
                title,
                condensedGeometry: geometry
              } = ride;
              if (geometry) {
                res.push({
                  type: 'Feature',
                  geometry,
                  properties: {
                    color: '#fff',
                    width: 9,
                    rideId,
                    title
                  }
                }, {
                  type: 'Feature',
                  geometry,
                  properties: {
                    color,
                    width: 5,
                    rideId,
                    title
                  }
                });
                if (_rides.find(({
                  id
                }) => id === prevRideId)) {
                  res.push({
                    type: 'Feature',
                    geometry: {
                      type: 'Point',
                      coordinates: geometry.coordinates[0][0]
                    },
                    properties: {
                      color,
                      step: true,
                      rideId,
                      title
                    }
                  });
                }
              }
            }
          });
          return res;
        }, [])
      });
    } else {
      clearBikeRoutesSource();
    }
  }, [initialized.current, _enabled, _rides, _bikeRoutes, selectedRideRef.current]);
  function select(ride, route, showSteps = false, isReturnRoute = false, animate = true) {
    if (ride === null) {
      selectedRideRef.current = null;
      selectRide(null);
      clearRoute();
      updateClusters();
      map?.setLayoutProperty(arrowRideLayerId, 'visibility', 'none');
      return;
    }
    if (ride.isLoop) {
      map?.setLayoutProperty(arrowRideLayerId, 'visibility', 'visible');
    } else {
      map?.setLayoutProperty(arrowRideLayerId, 'visibility', 'none');
    }
    if (selectedRideRef.current !== ride) {
      const {
        from,
        to,
        center,
        bounds,
        condensedGeometry,
        condensedReturnGeometry,
        steps,
        belongingBikeRoutes,
        isLoop
      } = ride;
      const bikeRoute = belongingBikeRoutes && bikeRoutes.current?.find(({
        id: bikeRouteId
      }) => belongingBikeRoutes.find(belongingBikeRoute => belongingBikeRoute.id === bikeRouteId));
      const color = bikeRoute?.primaryColor || '#326ac2';
      clearRoute();
      clearTooltips();
      clearMarkers();
      const _selectedRide = ride.clone();
      selectedRideRef.current = _selectedRide;
      selectRide(_selectedRide);
      const geometry = route?.geometry || (isReturnRoute ? condensedReturnGeometry : condensedGeometry);
      if (geometry) {
        const features = [{
          type: 'Feature',
          geometry,
          properties: {
            color: '#fff',
            width: 9
          }
        }, {
          type: 'Feature',
          geometry,
          properties: {
            color,
            width: 5
          }
        }];
        if (showSteps) {
          const departureCoordinates = geometry.type === 'MultiLineString' ? geometry.coordinates[0][0] : geometry.coordinates[0];
          const arrivalCoordinates = geometry.type === 'MultiLineString' ? geometry.coordinates[geometry.coordinates.length - 1].slice(-1)[0] : geometry.coordinates[geometry.coordinates.length - 1];
          features.push({
            type: 'Feature',
            geometry: from?.point || {
              type: 'Point',
              coordinates: departureCoordinates
            },
            properties: {
              color: isReturnRoute ? '#dd428d' : '#2ac682',
              step: true
            }
          });
          if (!isLoop) {
            features.push({
              type: 'Feature',
              geometry: to?.point || {
                type: 'Point',
                coordinates: arrivalCoordinates
              },
              properties: {
                color: isReturnRoute ? '#2ac682' : '#dd428d',
                step: true
              }
            });
          }
        }
        updateRidesSource({
          type: 'FeatureCollection',
          features
        });
        steps.sort((a, b) => a.order && b.order ? a.order - b.order : 0).forEach((step, index) => addRideStepMarker(step, index));
        if (bounds) {
          const {
            north,
            east,
            south,
            west
          } = bounds;
          map?.fitBounds(new _maplibreGl.LngLatBounds({
            lat: south,
            lng: west
          }, {
            lat: north,
            lng: east
          }), {
            padding: 50,
            animate
          });
        }
      } else if (center) {
        const {
          coordinates: [lat, lng]
        } = center;
        map?.flyTo({
          center: {
            lat,
            lng
          },
          animate
        });
      }
    }
  }
  function handleBikeRouteClick({
    originalEvent,
    features
  }) {
    if (!features || !features[0] || !features[0].properties || originalEvent.defaultPrevented) return;
    originalEvent.preventDefault();
    originalEvent.stopPropagation();
    const {
      rideId
    } = features[0].properties;
    if (rideId) select(rides.current?.find(({
      id
    }) => id === rideId) || null);
  }
  function init() {
    async function addArrowImage() {
      if (!map) return;
      try {
        const image = await map.loadImage(_mapArrow.default);
        if (image && !map.hasImage('arrow')) map.addImage('arrow', image.data);
      } catch (err) {
        console.error('err image', err);
      }
    }
    if (!map || initialized.current) return;
    if (getRidesSource()) {
      initialized.current = true;
      clear();
      return;
    }
    addRidesSource();
    addBikeRoutesSource();
    initClusters();
    addArrowImage();
    map?.addLayer({
      id: arrowRideLayerId,
      type: 'symbol',
      source: ridesSourceId,
      layout: {
        'symbol-placement': 'line',
        'symbol-spacing': 100,
        'icon-allow-overlap': true,
        'icon-image': 'arrow',
        'icon-size': 1,
        visibility: 'none'
      }
    });
    addLineLayer(ridesLayerId, ridesSourceId, {
      'line-join': 'round',
      'line-cap': 'round'
    }, {
      'line-color': ['get', 'color'],
      'line-width': ['get', 'width']
    }, {
      filter: ['!=', 'step', true]
    });
    addCircleLayer(ridesStepsLayerId, ridesSourceId, {
      'circle-radius': 6,
      'circle-stroke-width': 2,
      'circle-stroke-opacity': 1,
      'circle-color': ['get', 'color'],
      'circle-stroke-color': '#fff'
    }, {
      filter: ['==', 'step', true]
    });
    addLineLayer(bikeRoutesLayerId, bikeRoutesSourceId, {
      'line-join': 'round',
      'line-cap': 'round'
    }, {
      'line-color': ['get', 'color'],
      'line-width': ['get', 'width']
    });
    addCircleLayer(bikeRoutesStepsLayerId, bikeRoutesSourceId, {
      'circle-radius': 5,
      'circle-stroke-width': 2,
      'circle-stroke-opacity': 1,
      'circle-color': ['get', 'color'],
      'circle-stroke-color': '#fff'
    }, {
      filter: ['==', 'step', true]
    });
    map.on('mousemove', bikeRoutesLayerId, ({
      lngLat,
      features
    }) => {
      if (!features || !features[0] || !features[0].properties) return;
      map.getCanvas().style.cursor = 'pointer';
      const {
        title
      } = features[0].properties;
      addTooltip(lngLat, title);
    });
    map.on('click', bikeRoutesLayerId, handleBikeRouteClick);
    map.on('mouseleave', bikeRoutesLayerId, () => {
      map.getCanvas().style.cursor = '';
      clearTooltips();
    });
    map.on('mousemove', bikeRoutesStepsLayerId, event => {
      const {
        features
      } = event;
      if (!features || !features[0] || !features[0].properties) return;
      event.originalEvent.stopPropagation();
      map.getCanvas().style.cursor = 'pointer';
      const {
        geometry,
        properties: {
          title
        }
      } = features[0];
      if (geometry.type === 'Point') {
        const {
          coordinates: [lng, lat]
        } = geometry;
        addTooltip({
          lat,
          lng
        }, title);
      }
    });
    map.on('click', bikeRoutesStepsLayerId, handleBikeRouteClick);
    map.on('mouseleave', bikeRoutesStepsLayerId, () => {
      map.getCanvas().style.cursor = '';
      clearTooltips();
    });
    initialized.current = true;
  }
  function addMarker(ride) {
    if (!map) return;
    const {
      id,
      center,
      title,
      boundsCenter
    } = ride;
    const location = center ? {
      lat: center.coordinates[1],
      lng: center.coordinates[0]
    } : boundsCenter ? {
      lat: boundsCenter.coordinates[1],
      lng: boundsCenter.coordinates[0]
    } : null;
    if (id !== undefined && location && !markers.current[id]) {
      const marker = (0, _utils.createNewImageMarker)({
        color: '#326ac2'
      }, {
        onClick: () => onClick?.(rides.current?.find(ride => id === ride.id) || null),
        onMouseEnter: () => {
          addTooltip(location, title, 14);
          const geometry = ride.condensedGeometry || ride.condensedReturnGeometry;
          if (geometry) {
            const features = [{
              type: 'Feature',
              geometry,
              properties: {
                color: '#fff',
                width: 9
              }
            }, {
              type: 'Feature',
              geometry,
              properties: {
                color: '#326ac2',
                width: 5
              }
            }];
            updateRidesSource({
              type: 'FeatureCollection',
              features
            });
          }
        },
        onMouseLeave: () => {
          clearTooltips();
          clearRidesSource();
        }
      }).setLngLat(location).addTo(map);
      markers.current[id] = {
        id,
        marker
      };
    }
  }
  function addRideStepMarker(step, index) {
    if (!map) return;
    const {
      order,
      location,
      title,
      photos,
      poi,
      id
    } = step;
    if (location && (!!id || id === 0)) {
      const [lng, lat] = location.coordinates;
      let backgroundImage;
      if (photos[0]?.squaredThumbnailUrl) backgroundImage = photos[0].squaredThumbnailUrl;else if (poi?.photos[0]?.squaredThumbnailUrl) backgroundImage = poi.photos[0].squaredThumbnailUrl;else backgroundImage = _rideStepMarker.default;
      const popup = new _maplibreGl.Popup({
        maxWidth: '350px',
        closeButton: false,
        closeOnClick: true,
        className: 'map-custom-popup',
        offset: [0, -16]
      }).setHTML(`<div id="ride-step-${id}-popup"></div>`);
      popup.on('close', () => {
        if (selectedRideStepIdRef.current === id) unselectRideStep();
      });
      const marker = (0, _utils.createImageMarker)({
        id: `ride-step-marker-${order}`,
        radius: 16,
        borderWidth: 2,
        backgroundImage,
        text: `${index + 1}`
      }, {
        onClick: () => {
          if (selectedRideStepIdRef.current !== id) selectRideStep(step);
        },
        onMouseEnter: () => {
          if (selectedRideStepIdRef.current === id) return;
          const {
            anchor,
            offset
          } = (0, _utils.getAnchorAndOffset)(map, {
            lat,
            lng
          }, 18);
          rideStepTooltip.current?.remove();
          rideStepTooltip.current = new _maplibreGl.Popup({
            anchor,
            offset,
            className: 'map-tooltip',
            closeButton: false
          }).setHTML(`<span>${title}</span>`).setLngLat({
            lat,
            lng
          }).addTo(map);
        },
        onMouseLeave: () => clearTooltips()
      }).setLngLat({
        lat,
        lng
      }).setPopup(popup).addTo(map);
      stepMarkers.current[id] = {
        id,
        marker
      };
    }
  }
  function openRideStepPopup(step) {
    closePrevSelectedRideStepPopup();
    const {
      location
    } = step;
    const [lat, lng] = location ? [location.coordinates[1], location.coordinates[0]] : [];
    if (!!lng && !!lat) {
      const selectedMarker = selectedRideStepIdRef.current && stepMarkers.current[selectedRideStepIdRef.current];
      if (!selectedMarker) {
        unselectRideStep();
        return;
      }
      if (selectedMarker.marker.getPopup().isOpen()) return;
      selectedMarker.marker.togglePopup();
      const ele = document.getElementById(`ride-step-${step.id}-popup`);
      if (ele) {
        const container = (0, _client.createRoot)(ele);
        container.render(/*#__PURE__*/_react.default.createElement(_components.RideStepPopup, {
          onClose: () => {
            if (selectedMarker.marker.getPopup().isOpen()) selectedMarker.marker.togglePopup();
            if (container) container.unmount();
          },
          onEdit: onEdit ? () => onEdit(step) : undefined,
          onRemove: onRemove ? () => onRemove(step) : undefined,
          openPhotoDialog: step => openStepPhotoDialog?.(step),
          step: step,
          theme: theme
        }));
      }
      setTimeout(() => centerPopup({
        lat,
        lng
      }, selectedMarker.marker.getPopup()), 100);
    }
  }
  function closePrevSelectedRideStepPopup() {
    Object.values(stepMarkers.current).forEach(({
      id,
      marker
    }) => {
      if (id !== selectedRideStepIdRef.current && marker.getPopup().isOpen()) marker.togglePopup();
    });
  }
  function clearRoute() {
    clearRidesSource();
    Object.values(stepMarkers.current).forEach(({
      id,
      marker
    }) => {
      marker.remove();
      delete stepMarkers.current[id];
    });
  }
  function updateClusters() {
    clearMarkers();
    if (!enabled.current || selectedRideRef.current) return;
    const unclusteredFeatures = _updateClusters();
    unclusteredFeatures.forEach(({
      properties
    }) => {
      if (properties?.ride) addMarker(JSON.parse(properties.ride));
    });
  }
  function update(_rides) {
    clearMarkers();
    if (_rides) rides.current = _rides;
    if (!map || !rides.current) return;
    updateClustersData(rides.current.filter(ride => !!ride.center).map(ride => ({
      type: 'Feature',
      geometry: ride.center,
      properties: {
        ride
      }
    })));
    function init() {
      if (!map?.isSourceLoaded(clusterRidesSourceId)) return;
      updateClusters();
      map?.off('render', init);
    }
    map.on('render', init);
  }
  function selectRideStep(step) {
    if (typeof step.id !== 'number') return;
    selectedRideStepIdRef.current = step.id;
    selectRideStepId(step.id);
    openRideStepPopup(step);
  }
  function unselectRideStep() {
    selectedRideStepIdRef.current = null;
    closePrevSelectedRideStepPopup();
    selectRideStepId(null);
  }
  function addTooltip(location, title, _offset = 0) {
    clearTooltips();
    if (!map || !title) return;
    const {
      anchor,
      offset
    } = (0, _utils.getAnchorAndOffset)(map, location, _offset);
    rideTooltip.current = new _maplibreGl.Popup({
      anchor,
      offset,
      className: 'map-tooltip',
      closeButton: false
    }).setHTML(title).setLngLat(location).addTo(map);
  }
  function clearTooltips() {
    rideTooltip.current?.remove();
    rideStepTooltip.current?.remove();
  }
  function clearMarkers(markerId) {
    Object.values(markers.current).forEach(({
      id,
      marker
    }) => {
      if (markerId !== id) {
        marker.remove();
        delete markers.current[id];
      }
    });
    clearClusters();
  }
  function clear() {
    rides.current = [];
    updateClustersData([]);
    clearRoute();
    clearMarkers();
    clearTooltips();
  }
  return {
    initialized: initialized.current,
    selectedRide,
    selectedRideStepId,
    init,
    select,
    selectRideStep,
    unselectRideStep,
    update,
    updateClusters,
    clear
  };
}